<template>
  <div
    v-bind="$attrs"
    class="globaltitle"
  >
    <small
      v-if="$hasSlot('subtitle') || subtitle"
      class="globaltitle__subtitle text-uppercase"
    >
      <slot name="subtitle">
        {{ subtitle }}
      </slot>
    </small>

    <div
      data-grid="nowrap"
      :class="{ 'mt-4': $hasSlot('subtitle') || subtitle }"
      class="globaltitle__titlebox grid--va-center"
    >
      <figure
        data-grid="center-center"
        class="globaltitle__icon m-0 me-2"
      >
        <slot name="icon">
          <AsyncPhotographSolidIcon />
        </slot>
      </figure>

      <h1 class="globaltitle__textcontent m-0">
        <slot name="text-title">
          {{ textTitle }}
        </slot>
      </h1>
    </div>

    <p
      v-if="$hasSlot('description') || description"
      class="globaltitle__description m-0 mt-3"
    >
      <slot name="description">
        {{ description }}
      </slot>
    </p>
  </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue'

const AsyncPhotographSolidIcon = defineAsyncComponent(() => import('../icons/PhotographSolidIcon'))

export default defineComponent({
  name: 'GlobalTitle',

  components: {
    AsyncPhotographSolidIcon
  },

  props: {
    textTitle: {
      type: String,
      default: ''
    },

    subtitle: {
      type: String,
      default: ''
    },

    description: {
      type: String,
      default: ''
    }
  }
})
</script>

<style lang="scss" scoped>
  .globaltitle {
    margin: 0 0 32px;

    &__subtitle {
      letter-spacing: .1rem;
      color: var(--primary-dark2);
      font: 700 1rem "Nunito", sans-serif;
    }

    &__icon {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      background-color: rgba(var(--primary-rgb), .1);

      :slotted(svg) {
        width: 25px;
        color: var(--primary);
      }
    }

    &__textcontent {
      color: var(--primary-dark3);
      font: 600 2.1rem "Archivo", sans-serif;
    }

    &__description {
      color: rgb(var(--gray1));
      font: 700 1.4rem "Nunito", sans-serif;
    }
  }
</style>
